import styled from "styled-components";
import { Box, BoxProps } from "./Box";

interface ContainerProps extends BoxProps {
  // maxWidth?: "fluid" | "sm" | "md" | "lg";
}

const StyledBox = styled(Box)<ContainerProps>`
  margin: 0 auto;
`;

export const Container: React.FC<ContainerProps> = ({
  children,
  color,
  ...rest
}) => {
  return (
    <StyledBox paddingX={[3, 4]} {...rest}>
      {children}
    </StyledBox>
  );
};
